import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';

/**
 * GET /api/eraf/integration-hub/grpc/health — gRPC Health 조회 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'grpc', 'health']
 */
export function useGrpcHealth() {
  return useQuery({
    queryKey: ['integration-hub', 'grpc', 'health'],
    queryFn: () => integrationHubApi.getGrpcHealth(),
    staleTime: 30_000,
  });
}
